import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';
import { ButtonComponent } from '@fcom/ui-components/components/buttons/button/button.component';
import { IconComponent } from '@fcom/ui-components/components/icons/icon/icon.component';
import { BannerNotificationComponent } from '@fcom/ui-components/components/notifications/banner/banner.component';
import { PersonalizationModule } from '@fcom/loyalty-personalization';

import { GtmModule } from '../../gtm/gtm.module';
import { PipesModule } from '../../pipes/pipes.module';
import { DirectiveModule } from '../../directives/directive.module';
import { LoginModule } from '../../login/login.module';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CampaignBannerComponent } from './campaign-banner/campaign-banner.component';
import { HeaderComponent } from './header.component';
import { NavigationComponent } from './navigation/navigation.component';
import { NavigationTriggerModule } from './navigation-trigger.module';
import { ComponentsModule } from '../components.module';
import { MultivariateTestModule } from './../../multivariate-test/multivariate-test.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    PipesModule,
    DirectiveModule,
    NavigationTriggerModule,
    LoginModule,
    GtmModule,
    UiTranslateModule,
    PersonalizationModule,
    MultivariateTestModule,
    ButtonComponent,
    IconComponent,
    BannerNotificationComponent,
  ],
  declarations: [HeaderComponent, NavigationComponent, BreadcrumbComponent, CampaignBannerComponent],
  exports: [HeaderComponent, NavigationComponent, BreadcrumbComponent, CampaignBannerComponent],
})
export class NavigationModule {}
